import type { CameraPlatformId } from './camera-platform';
import { CAMERA_DISTANCES, type CameraDistanceId } from './camera-distance';
import { type CameraKeyframes, type CameraKeyframe } from '../../../renderer/src/camera-keyframes';
export * from '../../../renderer/src/camera-keyframes';

const lenses = [24, 50, 100, 200, 400, 800];
export const cameraLensMillimeters = (distance: CameraDistanceId) => lenses[CAMERA_DISTANCES.findIndex(item => item.id === distance)]!;
/** Preserve the six existing framing anchors while allowing smooth intermediate lens values. */
export function cameraLensZoomOffset(lens: number): number {
  const index = lenses.findIndex(value => value >= lens);
  if (index <= 0) return CAMERA_DISTANCES[index < 0 ? 5 : 0]!.zoomOffset;
  const low = lenses[index - 1]!, high = lenses[index]!;
  const amount = Math.log(lens / low) / Math.log(high / low);
  return CAMERA_DISTANCES[index - 1]!.zoomOffset + amount * (CAMERA_DISTANCES[index]!.zoomOffset - CAMERA_DISTANCES[index - 1]!.zoomOffset);
}
export function defaultCameraKeyframes(style: CameraPlatformId, distance: CameraDistanceId, pose?: { bearing: number; pitch: number }): CameraKeyframes & { version: 1 } {
  const constant = (value: number): CameraKeyframe[] => [{ seconds: 0, value, easing: 'smooth' }];
  return { version: 1, targetLock: true, rotation: constant(((pose?.bearing ?? 0) % 360 + 360) % 360),
    tilt: constant(pose?.pitch ?? (style === 'orbit' ? 55 : 36)), roll: constant(0), altitude: constant(style === 'orbit' ? 120 : 1200),
    lens: constant(cameraLensMillimeters(distance)) };
}
